/* Barkyn — Meta LP (lp-meta-july2026, PT)
   - Hero dog-name field -> quiz, forcing fresh branch and skipping the name step
   - Review filter chips
   - Before/after image slider
   - Comparison tabs (mobile)                                                */
(function () {
  'use strict';

  var QUIZ_URL = 'https://www.barkyn.com/pages/longevity-plan-quiz';

  // Build the quiz URL. Always force the fresh branch and the PROMO25 campaign code;
  // append the dog name if one was typed.
  function buildQuizUrl(dogName) {
    var url = QUIZ_URL + '?food=fresh&discount=PROMO25';
    var name = (dogName || '').trim().slice(0, 50);
    if (name) url += '&dog_name=' + encodeURIComponent(name);
    return url;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('hero-dog-name');

    // Hero CTA: read the name field, then go to the quiz.
    var heroCta = document.getElementById('hero-cta');
    function goFromHero() { window.location.href = buildQuizUrl(input && input.value); }
    if (heroCta) {
      heroCta.addEventListener('click', function (e) { e.preventDefault(); goFromHero(); });
    }
    if (input) {
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); goFromHero(); } });
    }

    // The other five CTAs carry food=fresh + the campaign code in their href already; only
    // the hero one needs JS, because only it can read the dog-name field.

    // Review filter chips — show only cards whose data-cats list includes the chip's filter.
    var filters = document.querySelectorAll('.filter');
    var reviewCards = document.querySelectorAll('.review-card');
    function applyFilter(f) {
      reviewCards.forEach(function (c) {
        var cats = (c.getAttribute('data-cats') || '').split(' ');
        c.style.display = cats.indexOf(f) !== -1 ? '' : 'none';
      });
    }
    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filters.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        applyFilter(btn.getAttribute('data-filter') || 'todos');
      });
    });
    var activeFilter = document.querySelector('.filter.is-active');
    applyFilter(activeFilter ? activeFilter.getAttribute('data-filter') : 'todos');

    // Before/after image sliders (cooked vs raw)
    document.querySelectorAll('.ba').forEach(function (ba) {
      var range = ba.querySelector('.ba__range');
      if (!range) return;
      function update() { ba.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', update);
      update();
    });
  });
})();

/* ----- Comparison tabs (mobile) ------------------------------------- */
(function () {
  var card = document.querySelector('.cmp__card');
  var tabs = document.querySelectorAll('.cmp__tab');
  if (!card || !tabs.length) return;
  for (var i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', function () {
      for (var j = 0; j < tabs.length; j++) tabs[j].classList.remove('is-active');
      this.classList.add('is-active');
      card.setAttribute('data-active', this.getAttribute('data-tab'));
    });
  }
})();
